export class SignUpModel {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  newPassword?: string;
  confirmPassword?: string;
  // Add more fields as needed

  constructor(
    firstName = "",
    lastName = "",
    email = "",
    password = "",
    newPassword = "",
    confirmPassword = ""
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.password = password;
    this.newPassword = newPassword;
    this.confirmPassword = confirmPassword;
  }
}
